import React from "react";
import PropTypes from "prop-types";

import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { USER_LOCAL_STORAGE_KEY } from "../data/constant";

const AuthContext = createContext();

export const AuthProvider = (props) => {
  const [user, setUser] = useLocalStorage(USER_LOCAL_STORAGE_KEY, null);

  const value = useMemo(() => ({ user, setUser }), [user]);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {props.children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node
};

export const useAuth = () => useContext(AuthContext);
